export function Telus(props) {
  return (
    <svg
      width='228'
      height='44'
      viewBox='0 0 228 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id='mask0_1343_344'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='228'
        height='44'
      >
        <path
          d='M227.857 0H0V44H227.857V0Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_1343_344)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M218.978 16.9056C214.385 15.869 212.779 15.7535 212.779 13.9256C212.779 12.2289 215.051 11.7 216.361 11.7C218.484 11.7 220.98 12.1931 223.526 13.5021L225.377 9.09479C222.773 7.66937 219.421 7.07812 216.195 7.07812C209.859 7.07812 205.61 9.64663 205.435 14.6562C205.25 19.2221 208.968 20.9345 212.383 21.6403C215.673 22.3186 219.012 22.9006 219.078 24.8569C219.141 26.6609 217.521 27.4326 214.46 27.4326C211.624 27.4326 208.991 26.5215 206.296 25.395L204.727 30.1826C207.818 31.5018 210.96 32.226 214.202 32.226C218.703 32.226 221.982 31.5256 224.402 29.256C226.079 27.6959 226.628 25.8139 226.628 24.0226C226.628 20.235 224.269 18.101 218.978 16.9056Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M187.378 7.78125V22.9988C187.378 24.1913 187.378 24.5213 187.303 24.9843C187.091 26.4346 185.678 27.2761 183.437 27.3043C181.778 27.2787 180.563 26.7883 179.996 25.9202C179.71 25.4721 179.573 24.6717 179.573 23.3938V7.78125H172.516V24.2886C172.516 26.5757 172.82 27.6061 173.85 28.9103C175.556 31.0472 178.878 32.1663 183.453 32.1663C183.5 32.1663 183.549 32.1663 183.599 32.1663C183.626 32.1663 183.666 32.1663 183.698 32.1663C189.826 32.1663 192.983 29.7738 193.901 27.5408C194.358 26.4583 194.395 25.9441 194.395 23.7568V7.78125H187.378Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M164.16 27.0066H153.785V7.78125H146.977V31.7328H164.16V27.0066Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M134.868 12.4388V7.78125H118.266V31.7328H134.868V26.8746H124.992V21.5661H133.207V16.9158H124.992V12.4388H134.868Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M108.609 12.5085V7.78125H87.7188V12.5085H94.777V31.7328H101.544V12.5085H108.609Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M90.9057 1.21862L51.3203 9.10012V11.8584L51.4487 11.8254C77.5976 5.47103 90.9057 1.65128 91.0138 1.62103C91.1623 1.58346 91.2128 1.46795 91.1926 1.37078C91.1725 1.26812 91.0652 1.1847 90.9057 1.21862Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M58.7189 0.464851C56.7939 0.575769 53.2318 3.42477 51.2774 5.11969C43.4876 11.8563 37.6979 18.051 33.4867 24.5384C24.7087 29.2372 13.519 34.0717 2.40534 37.8474L2.13859 37.9382L0 43.6975L1.221 43.2245C8.28941 40.5324 20.0869 35.4733 30.7826 29.8495C30.1794 31.4555 29.876 32.9304 29.876 34.2779C29.876 35.2844 30.0437 36.212 30.3811 37.0683C31.0549 38.7568 32.3776 40.041 34.2164 40.7725C36.9526 41.8643 40.6881 41.8854 44.9488 40.5955C55.8341 37.2929 68.7445 27.1674 71.5559 25.1534L71.6604 25.0764C71.7714 24.9985 71.7795 24.8775 71.731 24.7969C71.6705 24.7043 71.5421 24.6823 71.4349 24.7437L71.2974 24.8299C68.2797 26.6329 53.6222 35.3375 44.0935 37.895C39.2425 39.1977 35.5438 38.4835 34.1476 36.5329C33.6636 35.8674 33.4309 35.0223 33.4309 34.0369C33.4309 32.12 34.3329 29.6725 36.0754 26.9574C37.6786 26.0417 39.1729 25.1507 40.5212 24.3083C49.8181 19.0824 60.5275 8.92385 60.9821 2.72535C60.9849 2.68318 60.9849 2.6346 60.9849 2.58694C60.9849 2.05527 60.7539 1.50069 60.3488 1.09369C59.9134 0.650019 59.3376 0.428185 58.7189 0.464851ZM57.6831 3.42202C58.2945 3.02877 58.4705 3.27352 58.2917 3.71902C57.9984 4.42944 56.6601 8.71485 46.6931 16.8952C44.0935 19.0255 42.2428 20.2245 38.5009 22.4383C44.6306 13.8445 53.5829 6.08677 57.6831 3.42202Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M51.1872 9.12628L9.53935 18.0784L7.92969 22.4069L51.3155 11.8589L51.3834 11.8424V9.08594L51.1872 9.12628Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
